'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';


let settings = {
    fieldSelector: '.js-ajax-form__field',
    fieldNamePrefix: '.js-ajax-form__field--',
    contentSelector: '.js-ajax-form__content',
    errorClass: 'is-error'
};


class Form {
    constructor(el, options) {
        this.el = el;
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ Form/init ]', this.el);

        this.$form = $(this.el);
        this.$fields = this.opt.$fields || $(this.opt.fieldSelector, this.el);
        this.$content = this.opt.$content || $(this.opt.contentSelector).filter('[data-form_id="' + this.$form.data('form_id') + '"]');

        this._initFields();
        this._initEvents();

        //if ($.fancybox.isOpen) {
        //    $.fancybox.update();
        //}
    }
    submit() {
        console.log('[ Form/submit ]', this.el);

        if (!this.isLoading) {
            this._beforeSubmit();
            this._processSubmit();
            this._afterSubmit();
        }
    }
    _initFields() {
        let self = this;

        self.$fields.filter(this.opt.fieldNamePrefix + 'captcha').remove();
        self.$fields.find('[data-dependent]').on('change', function() {
            let dependentFieldName = $(this).data('dependent');
            let dependentField = self.$fields.filter(self.opt.fieldNamePrefix + dependentFieldName);
            console.log('[ Form/change field with dependent ]', this, dependentField);

            dependentField.find('input').prop('disabled', true).prop('checked', false).parent('label').parent('div').hide();
            let data = $(this).find('option:selected').data(dependentFieldName);
            if (data) {
                let values = data.split(',');
                $.each(values, function(index, value) {
                    dependentField.find('[value="' + value + '"]').prop('disabled', false).parent('label').parent('div').show();
                });
            }
            if ($(this).val() == -1) {
                dependentField.hide();
            } else {
                dependentField.show();
            }

        });
        self.$fields.find('[data-dependent]').change();
        /*$('input[type=file]').styler();*/
    }
    _initEvents() {
        this.$form.on('submit', (e) => {
            e.preventDefault();
            this.submit();
        });
    }
    _beforeSubmit() {
        this.isLoading = true;

        this.$fields.removeClass(this.opt.errorClass);

        //$.fancybox.showLoading();
    }
    _processSubmit() {
        let params = new FormData(this.el);

        Ajax.get('send_form', params).then((data) => {
            if (data.ok) {
                console.log('[ Form/_processSubmit ] Sent successfully');

                if (this.$form.data('goal')) {
                    $(window).trigger('ajaxForm:form:goal', this.$form.data());
                }

                if (this.$content.length) {
                    this.$content.html(data.content);
                    this.$form.remove();
                } else {
                    this.$form.replaceWith(data.content);
                }
                this._afterSubmit();
            } else if (data.errors) {
                console.log('[ Form/_processSubmit ] Got errors', data.errors);

                for (let p in data.errors) {
                    this.$fields.filter(this.opt.fieldNamePrefix + p).addClass(this.opt.errorClass);
                }
                if (data.errors.captcha) {
                    this.$fields.filter(this.opt.fieldNamePrefix + 'gcaptcha').addClass(this.opt.errorClass);
                    grecaptcha.ready(function () {
                        let _recaptcha = $('#recaptchaResponse').data('_recaptcha');
                        grecaptcha.execute(_recaptcha, { action: 'contact' }).then(function (token) {
                            var recaptchaResponse = document.getElementById('recaptchaResponse');
                            recaptchaResponse.value = token;
                        });
                    });
                }
                this._afterSubmit();
            }
        }).catch(function(error) {
            console.error('[ Form/_processSubmit ] Sending failed', error);

            this._afterSubmit();
        });
    }
    _afterSubmit() {
        //$.fancybox.hideLoading();

        //if ($.fancybox.isOpen) {
        //    $.fancybox.update();
        //}

        this.isLoading = false;
    }
}


export {
    Form
};
